<template>
  <v-dialog v-model="show" persistent width="450px" height="450px">
    <v-card>
      <div style="display: flex; justify-content: center; text-align:center">
        <div style="width: 350px; margin: 30px">
          <img src="@/assets/successImage.png" width="200px" height="150px" />
          <h5 class="mt-5 mb-6" style="color: #23409A"><slot></slot></h5>
          <v-btn style="background: #736F6F" class="main-btn mb-2 white--text" block @click="onClose" rounded large>กลับสู่แชท</v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    onClose() {
      this.show = false;
      this.$liff.closeWindow();
      this.$store.dispatch("messengerClose");
    },
  },
};
</script>
